import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import type { BirthdayRewardConfig } from './useBirthdayRewardConfigQuery'

interface SaveResult {
  success: boolean
  error?: string
}

async function saveBirthdayRewardConfig(config: BirthdayRewardConfig): Promise<void> {
  const { data, error } = await supabase.rpc('save_birthday_reward_config', {
    p_enabled: config.enabled,
    p_reward_item_id: config.rewardItemId,
  })

  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  const result = data as SaveResult
  if (!result?.success) {
    const failure = new Error(result?.error ?? 'save_failed')
    reportUnexpectedError(failure)
    throw failure
  }
}

export function useSaveBirthdayRewardConfig() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveBirthdayRewardConfig,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['birthday-reward-config'] }),
  })
}
